import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from 'vue-router';
import { type SelectProps } from 'ant-design-vue';
import CreateDocument from '@/components/disposable/CreateDocument.vue';
import { DocumentType } from '@/model/document';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateOnlyfansView',
  setup(__props) {

const route = useRoute();
const actorID = route.params.actorID as string;
const sources: SelectProps['options'] = [
	{ value: '', label: 'Please select source', disabled: true },
	{ value: 'onlyfans', label: 'Onlyfans' },
	{ value: 'myfans', label: 'Myfans (JP)' }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CreateDocument, {
    "document-type": _unref(DocumentType).Onlyfans,
    options: sources,
    metadataID: _unref(actorID)
  }, null, 8, ["document-type", "metadataID"]))
}
}

})